import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useIsLoggedIn } from '@ekonavi/auth';

interface AutoRouterProps {
  children: React.ReactNode;
}

export function AutoRouter({ children }: AutoRouterProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = useIsLoggedIn();

  useEffect(() => {
    // If logged in and on auth or home page, redirect to dashboard
    if (isLoggedIn && (location.pathname === '/' || location.pathname.startsWith('/auth'))) {
      navigate('/dashboard', { replace: true });
    }
    // If not logged in and trying to access protected routes, redirect to auth
    if (!isLoggedIn && !location.pathname.startsWith('/auth')) {
      navigate('/auth#login', { replace: true });
    }
    // If not logged in and on root, redirect to auth
    if (!isLoggedIn && location.pathname === '/') {
      navigate('/auth#login', { replace: true });
    }
  }, [isLoggedIn, location.pathname, navigate]);

  return <>{children}</>;
}